module.exports = __webpack_public_path__ + "8db93541af8419344e51583b74521f8e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/sofas/sofa-jam.png
// module id = 2896
// module chunks = 0